/**
 * Navigation Configuration - Centralized for ALL Portals
 * Role-aware menu items with consistent structure
 * Icons reference Lucide component names (see src/ui/icons.js)
 */

export const ADMIN_NAV = [
  { id: 'overview', label: 'Dashboard', icon: 'LayoutDashboard', path: '/admin/dashboard' },
  { id: 'applications', label: 'Applications', icon: 'FileText', path: '/admin/applications' },
  { id: 'underwriters', label: 'Underwriters', icon: 'Users', path: '/admin/underwriters' },
  { id: 'lenders', label: 'Lenders', icon: 'Landmark', path: '/admin/lenders' },
  { id: 'referrals', label: 'Referral Partners', icon: 'Share2', path: '/admin/referrals' },
  { divider: true, id: 'divider-1' },
  { header: 'Configuration', id: 'header-config' },
  { id: 'programs', label: 'Loan Programs', icon: 'ClipboardList', path: '/admin/programs' },
  { id: 'conditions', label: 'Document Conditions', icon: 'ClipboardCheck', path: '/admin/conditions' },
  { id: 'pricing', label: 'Pricing Matrix', icon: 'DollarSign', path: '/admin/pricing' },
];

export const UNDERWRITER_NAV = [
  { id: 'dashboard', label: 'Dashboard', icon: 'LayoutDashboard', path: '/uw/dashboard' },
  { id: 'pipeline', label: 'My Pipeline', icon: 'ClipboardCheck', path: '/uw/pipeline' },
  { id: 'queue', label: 'Unassigned Queue', icon: 'Inbox', path: '/uw/queue' },
];

export const LENDER_NAV = [
  { id: 'marketplace', label: 'Marketplace', icon: 'LineChart', path: '/lender/marketplace' },
  { id: 'bids', label: 'My Bids', icon: 'Gavel', path: '/lender/bids' },
  { id: 'portfolio', label: 'Portfolio', icon: 'Briefcase', path: '/lender/portfolio' },
];

export const BORROWER_NAV = [
  { id: 'dashboard', label: 'Dashboard', icon: 'Home', path: '/borrower/dashboard' },
  { id: 'application', label: 'My Application', icon: 'FileText', path: '/borrower/application' },
  { id: 'documents', label: 'Documents', icon: 'Files', path: '/borrower/documents' },
  { id: 'status', label: 'Application Status', icon: 'Activity', path: '/borrower/status' },
];

export const REFERRAL_NAV = [
  { id: 'dashboard', label: 'Dashboard', icon: 'LayoutDashboard', path: '/referral/dashboard' },
  { id: 'referrals', label: 'My Referrals', icon: 'Users', path: '/referral/referrals' },
  { id: 'earnings', label: 'Earnings', icon: 'DollarSign', path: '/referral/earnings' },
];

export const getNavigationForRole = (role) => {
  const navMap = {
    admin: ADMIN_NAV,
    underwriter: UNDERWRITER_NAV,
    lender: LENDER_NAV,
    borrower: BORROWER_NAV,
    referral: REFERRAL_NAV,
  };
  return navMap[role] || [];
};
